import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { AuthProvider } from "./auth/AuthContext";
import { ProgramAccessProvider } from "./hooks/useProgramAccess";
import ProtectedRoute from "./auth/ProtectedRoute";
import FeatureRoute from "./auth/FeatureRoute";

import AuthPage from "./pages/AuthPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Home2 from "./pages/Home2";
import LibraryPage from "./pages/LibraryPage";
import AboutUs from "./pages/AboutUs";
import Libraries from "./pages/Libraries";
import WeightCalculator from "./pages/WeightCalculator";
import NutritionGuide from "./pages/NutritionGuide";
import MyProgram from "./pages/MyProgram";
import Header2 from "./layouts/Header2";
import Footer2 from "./layouts/Footer2";

import "./assets/vendor/switcher/switcher.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import "./assets/css/style.css";
import "./assets/css/mobile.css";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [hash, pathname]);
  return null;
};

function App() {
  const Home2Layout = (
    <div className="page-wraper">
      <Header2 />
      <Home2 />
      <Footer2 />
    </div>
  );

  return (
    <AuthProvider>
      <ProgramAccessProvider>
        <ScrollToHash />
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={Home2Layout} />
          <Route path="/home2" element={Home2Layout} />
          <Route path="/home-2" element={Home2Layout} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/bmi-calculator"
            element={
              <ProtectedRoute>
                <div className="page-wraper">
                  <Header2 />
                  <FeatureRoute
                    feature="bmi_calculator"
                    title="BMI & Body Metrics Calculator"
                    description="This tool is available with packages that include the BMI Calculator feature. Choose an eligible package or ask the academy team to add it to your subscription."
                  >
                    <WeightCalculator />
                  </FeatureRoute>
                  <Footer2 />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/about-us"
            element={
              <div className="page-wraper">
                <Header2 />
                <AboutUs />
                <Footer2 />
              </div>
            }
          />
          <Route
            path="/libraries"
            element={
              <div className="page-wraper">
                <Header2 />
                <Libraries />
                <Footer2 />
              </div>
            }
          />
          <Route
            path="/nutrition-guide"
            element={
              <ProtectedRoute>
                <div className="page-wraper">
                  <Header2 />
                  <FeatureRoute
                    feature="nutrition_guide"
                    title="Hybrid Nutrition Guide"
                    description="The nutrition guide is available only while you are subscribed to a package that includes it."
                  >
                    <NutritionGuide />
                  </FeatureRoute>
                  <Footer2 />
                </div>
              </ProtectedRoute>
            }
          />
          {/* Requesting a program and following one share one destination. */}
          <Route path="/program-inquiry" element={<Navigate to="/my-program" replace />} />
          <Route path="/my-schedule" element={<Navigate to="/my-program" replace />} />
          <Route
            path="/library/:slug"
            element={
              <ProtectedRoute>
                <div className="page-wraper">
                  <Header2 />
                  <LibraryPage />
                  <Footer2 />
                </div>
              </ProtectedRoute>
            }
          />

          {/* Program (accessible to all; shows a login prompt if not authed) */}
          <Route
            path="/my-program"
            element={
              <div className="page-wraper">
                <Header2 />
                <MyProgram />
                <Footer2 />
              </div>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                {Home2Layout}
              </ProtectedRoute>
            }
          />

        </Routes>
      </ProgramAccessProvider>
    </AuthProvider>
  );
}

export default App;
